<div class="content density-lower">

  <section *ngIf="!showAccessPointSelection" class="backdrop-blur content-section">
    <form [formGroup]="loginForm" class="form-content density-mat-form-3">

      <div class="form-fields">
        <div class="form-field">
          <label> Login </label>
          <mat-form-field appearance="outline" class="background-white">
            <input type="text" formControlName="username" matInput maxlength="100" placeholder="Sem pontos ou hífens"
              data-cy="document" (keydown.enter)="onSubmit()">

            <mat-error *ngIf="loginForm.get('username').hasError('required')" data-cy="error-username-required">
              <strong> O campo é obrigatório </strong>
            </mat-error>

            <mat-error *ngIf="loginForm.get('username').hasError('email') && loginForm.get('username').touched" data-cy="error-email-invalid">
              <strong>E-mail inválido</strong>
            </mat-error>

          </mat-form-field>
        </div>

        <div class="form-field">
          <label> Senha </label>
          <mat-form-field appearance="outline" class="background-white">

            <input formControlName="password" matInput [type]="hidePassword ? 'password' : 'text'" maxlength="50"
              data-cy="password" (keydown.enter)="onSubmit()">

            <button mat-icon-button matSuffix data-cy="button-hide-password" (click)="hidePassword = !hidePassword"
              [attr.aria-pressed]="hidePassword">
              <mat-icon class="grey">{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>

            <mat-error *ngIf="loginForm.get('password').hasError('required')" data-cy="error-password-required">
              <strong> A senha é obrigatória </strong>
            </mat-error>

          </mat-form-field>
        </div>

        <re-captcha #recaptcha class="flex-center g-recaptcha" siteKey="6LdLTD8pAAAAAOx8qN7-_QmYK2oQsqmKTvNm-hop"
          data-cy="recaptcha"></re-captcha>

      </div>

      <div class="form-buttons">

        <app-button type="submit" (onClick)="onSubmit()" width="100%" [loading]="loading"
          [disabled]="!loginForm.valid || loading || !recaptchaResolved" color="primary" datacy="button-submit">
          <span class="estricta uppercase bolder"> Validar </span>
        </app-button>


        <button mat-button color="primary" routerLink="/recover" class="estricta uppercase white-bolder"
          data-cy="button-forgot-password">Esqueci minha senha</button>
      </div>

      <span class="biometric-button" *ngIf="hasBiometric" (click)="onSumitBio()" data-cy="biometric-button">
        <mat-icon class="biometric-icon">fingerprint</mat-icon>
      </span>
      <span *ngIf="detectar_mobile()">
        <button mat-raised-button color="primary" (click)="pwaService.installPwa()" *ngIf="!pwaService.isPwaInstalled()"
          data-cy="button-install-pwa">Instalar Aplicativo</button>
      </span>
    </form>

  </section>


  <section *ngIf="showAccessPointSelection" class="backdrop-blur content-section">
    <form class="form-content density-mat-form-3">

      <div *ngIf="selectedStructureType?.length > 0" class="form-field">
        <label>Tipo de estrutura:</label>
        <mat-radio-group
        [(ngModel)]="selectedStructureType" name="selectedStructureType"
        (change)="filterComissioners()"
        [value]="selectedStructureType"
        aria-label="Selecione tipo de estrutura">

          <mat-radio-button value="economicGroup">Grupo Econômico</mat-radio-button>
          <mat-radio-button value="pointOfSale">Ponto de Venda</mat-radio-button>
        </mat-radio-group>
      </div>
      <br>
      <form class="form-field" [formGroup]="selectedAccessPointForm">
         <app-custom-autocomplete label="Ponto de Acesso" [list]="filteredComissioners"  [enableVirtualScroll]="true" [chips]="false" displayKey="key" valueKey="value" formControlName="selectedAccessPoint" data-cy="accessPoint" placeholder="Selecione o ponto de acesso" [singleSelect]="true"/>
      </form>

      <div class="form-buttons">

        <app-button type="submit" (onClick)="onSubmitAccessPoint()" width="100%" [loading]="loading" color="primary" datacy="button-submit"
          [disabled]="selectedAccessPointForm.invalid || loading ">
          <span class="estricta uppercase bolder"> Entrar </span>
        </app-button>

      </div>
    </form>

  </section>
</div>
